import { render } from "./NaturezaJuridicaView.vue?vue&type=template&id=1704907d&scoped=true"
import script from "./NaturezaJuridicaView.vue?vue&type=script&lang=js"
export * from "./NaturezaJuridicaView.vue?vue&type=script&lang=js"

import "./NaturezaJuridicaView.vue?vue&type=style&index=0&id=1704907d&lang=scss&scoped=true"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1704907d"]])

export default __exports__